<template>
  <page>
    <div>
      <v-flex xs12>
        <form>
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex md6 xs6>
                        <v-text-field v-model="filter.team" :label="label.team" :error-messages="errors.collect('team')" data-vv-name="team" :data-vv-as="label.team"></v-text-field>
                      </v-flex>
                      <v-flex md6 xs6>
                        <v-autocomplete :items="divisionList" v-model="filter.division" :label="label.division" item-text="label" item-value="value" data-vv-name="division" :data-vv-as="label.division" :error-messages="errors.collect('division')" clearable></v-autocomplete>
                      </v-flex>
                      <v-flex md6 xs6>
                        <v-autocomplete :items="sectorList" v-model="filter.sector" :label="label.sector" item-text="label" item-value="value" data-vv-name="sector" :data-vv-as="label.sector" :error-messages="errors.collect('sector')" clearable></v-autocomplete>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
        <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="doNew">
            New Team<v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-flex>
          <v-card>
            <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td class="text-xs-left">{{ row.item.team }} </td>
                <td class="text-xs-left">{{ row.item.division }} </td>
                <td class="text-xs-left">{{ row.item.sector }} </td>
                <td class="text-xs-left">{{ row.item.teamDesc }} </td>
                <td class="table-action-header">
                  <table-action :rowData="row" review @review="doReview(row.item)" query @query="doQuery(row.item)" remove @remove="doPromptRemove(row.item)"></table-action>
                </td>
              </tr></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doDelete">
        <p>Are you sure you want to delete the Team?</p>
        <div class="queryValue">Team: {{selected.team}}<br/>
          Division: {{selected.division}}<br/>
          Sector: {{selected.sector}}<br/>
          Team Description: {{selected.teamDesc}}
        </div>
      </confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      toogleArray: [false],
      divisionList: [],
      sectorList: [],
      label: {
        team: 'Team',
        division: 'Division',
        sector: 'Sector',
        teamDesc: 'Division Description'
      },
      filter: {
        team: null,
        division: null,
        sector: null
      },
      loading: false,
      totalItems: 0,
      headers: [
        { text: 'Team', align: 'left', value: 'team' },
        { text: 'Division', align: 'left', value: 'division' },
        { text: 'Sector', align: 'left', value: 'sector' },
        { text: 'Team Description', align: 'left', value: 'teamDesc' },
        TableConst.tableActionHeader
      ],
      promptRemove: false,
      selected: {
        team: null,
        division: null,
        sector: null,
        teamDesc: null
      },
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  async mounted() {
    await this.$store.dispatch('teamInit')
    this.fetchData(true)
    this.doInit()
  },
  methods: {
    async doInit() {
      this.fetchData(true)
      this.fetchDivisionList()
      this.fetchSectorList()
    },
    async fetchData(options) {
      this.resetMessages()
      const apiURI = this.menu.getTeamList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filter, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  team: datamap.team,
                  division: datamap.division,
                  sector: datamap.sector,
                  teamDesc: datamap.teamDesc
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    async fetchDivisionList() {
      const apiUrl = this.menu.divisionList
      if (apiUrl) {
        try {
          this.divisionList = []
          const result = await this.$http.get(apiUrl)
          if (result.data.dataList) {
            this.$set(this, 'divisionList', result.data.dataList)
          }
        } catch (err) {
          this.divisionList = []
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async fetchSectorList() {
      const apiUrl = this.menu.sectorList
      if (apiUrl) {
        try {
          this.sectorList = []
          const result = await this.$http.get(apiUrl)
          if (result.data.dataList) {
            this.$set(this, 'sectorList', result.data.dataList)
          }
        } catch (err) {
          this.sectorList = []
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filter.team = null
      this.filter.division = null
      this.filter.sector = null
      this.fetchData(false)
    },
    doFilters() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.fetchData(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doPromptRemove(data) {
      this.resetMessages()
      if (data) {
        try {
          const apiURI = this.menu.checkDeleteTeam
          const expand = {
            team: data.team,
            division: data.division,
            sector: data.sector
          }
          await this.$http.get(expandURI(apiURI, expand))
          this.selected.team = data.team
          this.selected.division = data.division
          this.selected.sector = data.sector
          this.selected.teamDesc = data.teamDesc
          this.promptRemove = true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fieldMessage(data)
            this.notify(data)
          }
        }
      }
    },
    doDelete() {
      this.resetMessages()
      if (this.selected && this.selected.team) {
        const apiURI = this.menu.deleteTeam
        if (apiURI) {
          const expand = {
            team: this.selected.team,
            division: this.selected.division,
            sector: this.selected.sector
          }
          this.$http
            .post(apiURI, expand)
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.fetchData(false)
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    },
    doNew() {
      const commit = {
        tranMode: 'New',
        team: null,
        division: null,
        sector: null,
        teamDesc: null
      }
      sessionStorage.setItem('team', JSON.stringify(commit))
      this.$store.commit('TEAM_COMMIT_KEY', commit)
      this.$router.push({ name: 'teamReview' })
    },
    doQuery(data) {
      const commit = {
        tranMode: 'Query',
        team: data.team,
        division: data.division,
        sector: data.sector,
        teamDesc: data.teamDesc
      }
      sessionStorage.setItem('team', JSON.stringify(commit))
      this.$store.commit('TEAM_COMMIT_KEY', commit)
      this.$router.push({ name: 'teamReview' })
    },
    doReview(data) {
      const commit = {
        tranMode: 'Review',
        team: data.team,
        division: data.division,
        sector: data.sector,
        teamDesc: data.teamDesc
      }
      sessionStorage.setItem('team', JSON.stringify(commit))
      this.$store.commit('TEAM_COMMIT_KEY', commit)
      this.$router.push({ name: 'teamReview' })
    }
  },
  computed: {
    menu() {
      return this.$store.state.boIncenSchParam.team.menu
    }
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  mixins: [TableConst.default, MessageMixin, commonAjaxMixin]
}
</script>
